import React, { FC } from "react";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import "./styles/footer.scss";

interface FooterLinkItemProps {
  title: string;
  linkUrl: string;
  isEmail?: boolean;
  isPhone?: boolean;
}

const FooterLinkItem: FC<FooterLinkItemProps> = (props) => {
  const { title, linkUrl, isEmail, isPhone } = props;
  const navigate = useNavigate();

  const handleClick = () => {
    if (isEmail) {
      window.location.href = `mailto:${linkUrl}`;
    } else if (isPhone) {
      window.location.href = `tel:${linkUrl}`;
    } else {
      navigate(linkUrl);
    }
  };

  return (
    <motion.div
      tabIndex={0}
      role="link"
      className="footerSectionContentItem"
      onClick={handleClick}
      onKeyDown={(e) => e.key === "Enter" && handleClick()}
      whileHover={{ x: 4 }}
      transition={{ type: "spring", stiffness: 400, damping: 25 }}
    >
      <Typography variant="body2" sx={{ color: "var(--color-text-secondary)" }}>
        {title}
      </Typography>
    </motion.div>
  );
};

export default FooterLinkItem;
